/**
 * **열두 달을 세기 시작하는 달** (`YYYY-MM`).
 *
 * 달력 달의 남은 날이 7일 이하면 다음 달부터 센다 — 10/31 에 "좋은 달 10월", "지금부터 이달 말까지 시작하기 좋다"
 * (남은 날 하루)가 나왔다. 리포트·궁합·공부 12개월·배경화면의 "이번 달" 이 모두 이 달을 쓴다.
 * 캐시 열쇠도 이 달로 잡는다 — 글은 다음 달부터인데 열쇠는 이번 달이면 두 글이 한 열쇠에 섞인다.
 */
export const MONTH_TAIL_DAYS = 7

export function baseMonth(today: string): string {
  const y = Number(today.slice(0, 4))
  const m = Number(today.slice(5, 7))
  const d = Number(today.slice(8, 10))
  const last = new Date(Date.UTC(y, m, 0)).getUTCDate()
  return last - d > MONTH_TAIL_DAYS ? today.slice(0, 7) : monthAfter(today.slice(0, 7))
}

/** "2026-12" → "2027-01" */
export function monthAfter(ym: string): string {
  const y = Number(ym.slice(0, 4))
  const m = Number(ym.slice(5, 7))
  return m === 12 ? `${y + 1}-01` : `${y}-${String(m + 1).padStart(2, '0')}`
}

/** 기준 달이 이미 시작된 달(오늘이 든 달력 달)인가 — 아니면 "지금부터" 가 아니라 그 달 이름으로 쓴다 */
export function baseMonthStarted(today: string): boolean {
  return baseMonth(today) === today.slice(0, 7)
}
